import React, { Component } from 'react';

export default class CustomCampaignFloatingFilter extends Component {
  constructor(props) {
    super(props);
    const columnName = props?.column?.colDef?.field;
    const searchColumn = props?.context?.componentParent?.state?.searchColumn;
    const searchParam = props?.context?.componentParent?.state?.searchParam;

    this.state = {
      value: searchColumn === columnName ? searchParam : '',
    };
    this.debounceTimeout = null; // Timeout reference for debouncing
  }

  onInputChange = (event) => {
    const columnName = this.props?.column?.colDef?.field;
    const newValue = event.target.value;

    // Clear the previous timeout
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }

    // Set a new timeout to delay the execution
    this.debounceTimeout = setTimeout(() => {
      this.props?.context?.componentParent?.columnSearch(columnName, newValue);
    }, 300); // 300ms debounce delay


    this.setState({ value: newValue });

    // Pass filter value to parent via parent filterInstance
    // this.props.parentFilterInstance((instance) => {
    //   instance.onFloatingFilterChanged('contains', newValue);
    // });
  };

  render() {
    return (
      <input
        type="text"
        placeholder="Search..."
        value={this.state.value}
        onChange={this.onInputChange}
        style={{ width: '100%' }}
      />
    );
  }
}
